import { render, staticRenderFns } from "./recently_event.vue?vue&type=template&id=63368ee6&scoped=true&"
import script from "./recently_event.vue?vue&type=script&lang=js&"
export * from "./recently_event.vue?vue&type=script&lang=js&"
import style0 from "./recently_event.vue?vue&type=style&index=0&id=63368ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63368ee6",
  null
  
)

export default component.exports